import React, { Component } from 'react'
import StatusList from 'src/components/arrival-status-list-component/status-list-component';
// images
const bags_in_van = require('../../images/preslot_inbound_header.svg');
// styles
const styles = require('./ccd-bags-delivered.scss');

export enum BagsJourneyType {
  Collected = 1,
  InTransit = 2,
  InStorage = 3,
  OutOfStorage = 4,
  CheckedIn = 5,
  Downgraded = 6,
  WithCourier = 7,
  Delivered = 8,
  NotCollected = 9
}

export enum BagsJourneyStatus {
  Pending = 1,
  InProgress = 2,
  Completed = 3,
  UrgentAttention = 4,
  PartiallyCompleted = 5
}

interface IProps {
  trackingData: any;
  language: string;
  multiLang: any;
}

export class ArrivalBagsDeliveredComponent extends Component<IProps, any> {
  render() {
    const { language, multiLang, trackingData } = this.props;
    const { arrivalCompletedTrackingStatus, bagsJourney } = trackingData;

    const title = multiLang[arrivalCompletedTrackingStatus.titleDisplay + language];
    const subtitle = multiLang[arrivalCompletedTrackingStatus.subTitle + language];
    const text = isNaN(arrivalCompletedTrackingStatus?.text[0]) ? arrivalCompletedTrackingStatus?.text : arrivalCompletedTrackingStatus?.text[0] === '1' ? arrivalCompletedTrackingStatus?.text : '%s' + arrivalCompletedTrackingStatus?.text.substr(1)

    const description = multiLang[text + language]?.replace('%s', arrivalCompletedTrackingStatus?.text[0]) || arrivalCompletedTrackingStatus.text;

    // const description = multiLang[arrivalCompletedTrackingStatus.text + language];
    const {bookedBagCount, collectedBagCount} = arrivalCompletedTrackingStatus;
    const supportLink = {
      '': 'https://support.airportr.com/hc/en-us/articles/4403885089169-Arrivals-What-if-my-bag-isn-t-on-the-baggage-reclaim-at-my-destination',
      '_fr': 'https://support.airportr.com/hc/de/articles/4403885089169-Was-ist-wenn-mein-Gep%C3%A4ck-an-meinem-Zielort-nicht-auf-der-Gep%C3%A4ckausgabe-steht',
      '_de': 'https://support.airportr.com/hc/de/articles/4403885089169-Was-ist-wenn-mein-Gep%C3%A4ck-an-meinem-Zielort-nicht-auf-der-Gep%C3%A4ckausgabe-steht'
    };
    const warningMessage = multiLang['Bags collected from carousel' + language];
    return (
      <div className={styles.mainContent}>
        <div className={styles.sectionWrapper}>
          <div className={styles.section}>
            <div className={styles.card}>
              <div className={styles.cardBody}>
                <h1 className={styles.heading}>{title}</h1>

                <div className={styles.group}>
                  <div>
                    <img src={bags_in_van} />
                    <h3 className={styles.subHeading}>
                      {subtitle}
                    </h3>
                    {(collectedBagCount !== bookedBagCount) && <p className={[styles.warning, styles.description, styles.mb_12].join(' ')}>
                      {collectedBagCount + '/' + bookedBagCount + ' ' + warningMessage}
                    </p>}
                    <p className={styles.description}>
                      {description}
                    </p>
                    {(collectedBagCount !== bookedBagCount) && <a target='_blank' href={supportLink[language]}>{multiLang['How do I find my missing bag?' + language]}</a>}
                  </div>

                  <div>
                    <StatusList
                      bagsJourney={bagsJourney}
                      multiLang={multiLang}
                      language={language}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ArrivalBagsDeliveredComponent



// WEBPACK FOOTER //
// ./src/containers/ccd-bags-delivered/ccd-bags-delivered.component.tsx